import axios from "axios";
import { HOST_URL } from "./Host";

export const SET_PROCEDURES = "SET_PROCEDURES";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Accept-Version": "2.0",
};

export function setProcedures(procedures) {
  return {
    type: SET_PROCEDURES,
    payload: procedures,
  };
}

export function fetchUserProcedures(token, limit = 100) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${HOST_URL}/requests?limit=${limit}`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      await dispatch(setProcedures(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

export function fetchOperatorProcedures(token, country, limit = 100) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${HOST_URL}/requests?country=${country}&limit=${limit}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setProcedures(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

export function fetchAdminProcedures(token, limit = 100) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${HOST_URL}/requests?limit=${limit}`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      await dispatch(setProcedures(response.data.data));
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

export function assignProcedure(token, data, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${HOST_URL}/requests/assign`, data, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      //   await dispatch(setProcedures(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function closeProcedure(token, data, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/requests/terminate`,
        data,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      //   await dispatch(setProcedures(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function rejectProcedure(token, data, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${HOST_URL}/requests/reject`, data, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });

      //   await dispatch(setProcedures(response.data.data));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}
